exports.install = function (Vue, options) {
  Vue.prototype.language = 'cn'
  Vue.prototype.locale = function (en, cn) {
    if (this.language == 'en') {
      return en
    } else {
      return cn
    }
  }
}
